<template>
    <div>
        <b-overlay :show="is_load">
            <form class="user" autocomplete="off">

            <div class="form-group">
                <label class="form-label" for="input-live-feedback_username">
                    {{__t('TURBO_USERNAME')}}
                </label>
                <b-form-input
                    id="input-live-feedback_username"
                    v-model="turbo_sms.turbo_username"
                    class="form-control form-control-use"
                    :placeholder="__t('TURBO_USERNAME')"
                >
                </b-form-input>
            </div>

            <div class="form-group">
                <label class="form-label" for="input-live-turbo_password">
                    {{__t('TURBO_PASSWORD')}}
                </label>
                <b-form-input
                    id="input-live-turbo_password"
                    v-model="turbo_sms.turbo_password"
                    class="form-control form-control-use"
                    :placeholder="__t('TURBO_PASSWORD')"
                >
                </b-form-input>
            </div>

            <div class="form-group">
                <label class="form-label" for="input-live-turbo_alpha">
                    {{__t('TURBO_ALPHA')}}
                </label>
                <b-form-input
                    id="input-live-turbo_alpha"
                    v-model="turbo_sms.turbo_alpha"
                    class="form-control form-control-use"
                    :placeholder="__t('TURBO_ALPHA')"
                >
                </b-form-input>
            </div>

            <div class="panel-tag mt-3 mb-3">
                <p>{order_code}     - ORDER_CODE</p>
                <p>{rest_title}     - REST_TITLE</p>
                <p>{rest_phone}     - REST_PHONE</p>
                <p>{customer_name}  - CUSTOMER NAME</p>
            </div>


            <div class="form-group">
                <label class="form-label" for="input-live-message">
                    {{__t('TURBO_SMS_TEXT')}}
                </label>

                <b-form-textarea
                    id="textarea"
                    v-model="turbo_sms.message"
                    placeholder="SMS"
                    rows="3"
                    max-rows="6"
                ></b-form-textarea>
            </div>

        </form>
        </b-overlay>
    </div>
</template>

<script>
export default {
    name: "turbo_sms",
    props : {
        rest : {
            type : Object
        }
    },
    data() {
        return {
            is_load: false,
        }
    },

    created() {
        EventBus.$on('save_rest_called',this.save_turbo_settings)
        this.load_turbo_settings(this.rest.id);
    },

    methods : {
        async save_turbo_settings() {

        },

        async load_turbo_settings(rest_id) {
            this.is_load = true;
            let url = '/sms/restaurant/'+ rest_id +'/turbo_sms/attached';

            notification_api.get(url).then(({data}) => {
                if (data.status === "operation_success") {
                    this.$set(this.rest, 'turbo_sms', data.data);
                    this.is_load = false;
                }

            }).catch(({response}) => {
                this.is_load = false;
                EventBus.$emit('show_toast', {
                    err: response.data.message,
                    type: "danger",
                    title: response.data.status
                })
            });
        } ,
    },

    computed: {
        turbo_sms()  {

            console.log('recomup');
            if(this.rest.hasOwnProperty("turbo_sms")) {
                return this.rest.turbo_sms;
            }

            return {
                'turbo_username': "",
                'turbo_password': "",
                'turbo_alpha': "",
                'message': ""
            }
        }
    },



}
</script>

<style scoped>

</style>
